module.exports = __webpack_public_path__ + "media/secondSection/green-circle-507666a4.png";